import { Controller } from "stimulus"

export default class extends Controller {
  reset(){
    localStorage.removeItem("costEstimate-slider")
    localStorage.removeItem("costEstimate-rooms")
    localStorage.removeItem("costEstimate-quality")
    localStorage.removeItem("cost-calculator-total")
    localStorage.removeItem("cost-calculator-stages")

    $(this.element).find(".slider").each(function(index, element){
      var defaultValue = element.defaultValue || element.getAttribute("value") || 10
      $(element).val(defaultValue)
      $(element).closest(".type-item").find("[data-target='cost-estimate-slider.value']").text(defaultValue + " Sq M")
    })

    $(this.element).find(".room-number").each(function(index, element){
      $(element).text($(element).data("default-value") || 1)
    })

    $(this.element).find(".select-quality").val("low")
    $(this.element).find(".quality-current-value").text("Low-end").removeClass("opened")
    $(this.element).find(".quality-dropdown").addClass("d-none")
    $(this.element).find(".quality-dropdown .item").removeClass("selected")
    $(this.element).find(".quality-dropdown .item[data-value='low']").addClass("selected")

    let event_calculate = document.createEvent("Events")
    event_calculate.initEvent("calculateCost", true, true)
    window.dispatchEvent(event_calculate)
  }
}
